import { useEffect } from 'react';

const ChatwootWidget = () => {
  useEffect(() => {
    // Only load Chatwoot if it hasn't been loaded already
    if (window.chatwootSDK) {
      return;
    }

    // Create script element
    const script = document.createElement('script');
    const BASE_URL =
      process.env.REACT_APP_CHATWOOT_URL || 'https://support.jabav.cloud';

    script.src = `${BASE_URL}/packs/js/sdk.js`;
    script.defer = true;
    script.async = true;

    console.log(
      'LOADING CHATWOOT WIDGET',
      BASE_URL,
      process.env.REACT_APP_CHATWOOT_TOKEN
    );

    // Add onload handler
    script.onload = function () {
      window.chatwootSDK.run({
        websiteToken: process.env.REACT_APP_CHATWOOT_TOKEN,
        baseUrl: BASE_URL
      });
      console.log('CHATWOOT WIDGET LOADED');
    };

    // Insert script into DOM
    document.head.appendChild(script);

    // Cleanup function
    return () => {
      // Remove script if component unmounts
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  // This component doesn't render anything visible
  return null;
};

export default ChatwootWidget;
